var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCupIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 77,
    viewBox: "0 0 95 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H91C93.2091 0 95 1.79086 95 4V73C95 75.2091 93.2091 77 91 77H4C1.79086 77 0 75.2091 0 73V4Z",
    fill: "#020C41"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1641 59.334H55.8307",
    stroke: "white",
    strokeWidth: 3.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0859 34.334H57.9193",
    stroke: "white",
    strokeWidth: 3.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5 44.75V59.3333",
    stroke: "white",
    strokeWidth: 3.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5026 44.7493C50.2653 44.7493 52.9148 43.6519 54.8683 41.6984C56.8218 39.7449 57.9193 37.0954 57.9193 34.3327C57.9193 30.166 56.8776 25.9993 53.7526 17.666H41.2526C38.1276 25.9993 37.0859 30.166 37.0859 34.3327C37.0859 37.0954 38.1834 39.7449 40.1369 41.6984C42.0904 43.6519 44.7399 44.7493 47.5026 44.7493Z",
    stroke: "white",
    strokeWidth: 3.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCupIcon);
export default __webpack_public_path__ + "static/media/cup-icon.1e9fb702c9fe621ce0a57b15b911a135.svg";
export { ForwardRef as ReactComponent };